import React, { useEffect, useState } from 'react'
import { addLocalStorageData } from '../../utils/localCache.util';
import { getMenuDetails, searchData } from '../../services/channelData.service';
import { VIDEO_TYPES } from '../../config/const.config';
import Loading from './Loading';
import DetailPage from '../pages/DetailPage';
import PpcDetailsPage from '../pages/PpcDetailsPage';

const DetailPageWrapper = ({ activePage, menuData, activePageLayout, handlePageChange, landingPageButton }) => {
    const [detailData, setDetailData] = useState(null);
    const [videos, setVideos] = useState([]);
    const [activeSubPage, setActiveSubPage] = useState("");
  
    useEffect(() => {
      const fetchData = async () => {
          const playlistCategoryTitle = window.location.pathname.split('/')[2];
          const videoTitleSlug = window.location.pathname.split('/')[3];
          setActiveSubPage(playlistCategoryTitle);
          addLocalStorageData('pageClick', activePage);
          try {
            const menuData = await getMenuDetails(activePage);
            const matchingPlaylist = menuData?.content?.playlists?.find(
              (playlist) => String(playlist.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w-]/g, '')) === playlistCategoryTitle
            );
  
            const program_type = matchingPlaylist?.program_type ?? 'videos';
            const response = await searchData(videoTitleSlug);            
            const rawVideos = response.content.videos || response.content.movies || response.content.events || [];
            const formattedVideos = rawVideos.map((v) => ({
              id: v._id,
              playlist_id: v.playlist_id,
              title: v.title,
              description: v.description || '',
              shortDescription: v.short_description || '',
              hlsUrl: v.hls_url,
              poster: v.poster,
              posterH: v.poster_16_9,
              posterV: v.poster_9_16,
              startTime: v.start_date_time || '',
              endTime: v.end_date_time || '',
              duration: Number(v.duration || 0),
              genres: v.genres || '',
              category: v.category || '',
              channelId: Number(v.channel_id),
              director: v.director || '',
              actor1: v.actor1 || '',
              actor2: v.actor2 || '',
              actor3: v.actor3 || '',
              rating: v.rating || '',
              ratingSource: v.rating_source || '',
              releaseDate: v.releaseDate || '',
              season: Number(v.season || 0),
              episode: Number(v.episode || 0),
              srtUrl: v.srt_url || '',
              vttUrl: v.vtt_url || '',
              source: v.source || '',
              playDirectUrl: v.playDirectUrl || '',
              liveVastUrl: v.liveVastUrl || '',
              type: program_type,
              isPortrait: program_type === VIDEO_TYPES.MOVIES,
              ppc_spotlight_active: v?.ppc_spotlight[0]?.ppc_spotlight_active,
              background_image_video: v?.ppc_spotlight[0]?.background_image_video,
              background_video_url: v?.ppc_spotlight[0]?.background_video_url,
              ppc_background_image: v?.ppc_spotlight[0]?.background_url,
              ppc_dark_overlay: v?.ppc_spotlight[0]?.ppc_dark_overlay,
              ppc_watch_now_url: v?.ppc_spotlight[0]?.ppc_watch_now_url,
              ppc_trailer_url: v?.ppc_spotlight[0]?.ppc_trailer_url,
            }));
            setDetailData(formattedVideos[0]);
            setVideos(formattedVideos);
          } catch (error) {
            console.error('Error fetching detail data:', error);
          }
      };
  
      fetchData();
    }, [activePage]);
  
    if (!detailData) {
      return <Loading showVideo={false} />;
    }
  
    return detailData.ppc_spotlight_active === "1" ? (
      <PpcDetailsPage
        key={detailData.id || detailData._id}
        detailPageData={detailData}
        videos={videos}
        containerIdPrefix={`item${detailData.id || detailData._id}`}
        activePage={activePage}
        activeSubPage={activeSubPage}
        handleHideDetailPage={() => {}}
        setShowDetailPage={() => {}}
        menuData={menuData}
        activePageLayout={activePageLayout}
        handlePageChange={handlePageChange}
        landingPageButton={menuData[0].id}
      />
    ) : (
      <DetailPage
        key={detailData.id || detailData._id}
        detailPageData={detailData}
        videos={videos}
        containerIdPrefix={`item${detailData.id || detailData._id}`}
        activePage={activePage}
        activeSubPage={activeSubPage}
        handleHideDetailPage={() => {}}
        setShowDetailPage={() => {}}
        menuData={menuData}
        activePageLayout={activePageLayout}
        handlePageChange={handlePageChange}
        landingPageButton={menuData[0].id}
      />
    );
    };

export default DetailPageWrapper
